import React from 'react';

import { LinkableTransmitterStepsProviderState } from 'features/residents/resident-settings/components/resident-setting-details/components/devices-accordion/components/details-devices/components/linkable-transmitter-steps/providers/states/linkable-transmitter-steps-provider-state';

const LinkableTransmitterStepsProviderContext = React.createContext<LinkableTransmitterStepsProviderState>({} as never);

export default LinkableTransmitterStepsProviderContext;
